export default "__VITE_ASSET__DdWF64K4__"